<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="card card-signin my-5">
          <div class="card-body">
            <h5 class="card-title text-center">Register</h5>
            <form @submit.prevent="register" class="form-signin">
              <div class="form-label-group">
                <input
                  type="text"
                  id="inputName"
                  class="form-control"
                  v-model="name"
                  placeholder="Name"
                  required
                  autofocus
                />
                <label for="inputName">Name</label>
              </div>
              <div class="form-label-group">
                <input
                  type="email"
                  id="inputEmail"
                  class="form-control"
                  v-model="email"
                  placeholder="Email address"
                  required
                  autofocus
                />
                <label for="inputEmail">Email address</label>
              </div>

              <div class="form-label-group">
                <input
                  type="password"
                  id="inputPassword"
                  class="form-control"
                  v-model="password"
                  placeholder="Password"
                  required
                />
                <label for="inputPassword">Password</label>
              </div>

              <div class="form-label-group">
                <input
                  type="password"
                  id="inputConfirmPassword"
                  class="form-control"
                  v-model="confirmPassword"
                  placeholder="Confirm Password"
                  required
                />
                <label for="inputConfirmPassword">Confirm Password</label>
              </div>
              <button class="btn btn-lg btn-primary btn-block text-uppercase" type="submit">Register</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Register",
  data() {
    return {
      name: "",
      email: "",
      password: ""
    };
  },
  methods: {
    register() {
      let email = this.email,
        name = this.name,
        password = this.password;
      this.$store
        .dispatch("register", { email, name, password })
        .then(() => this.$router.push("login"))
        .catch(err => {
          this.error = "User could not be registered at the moment.";
        });
    }
  }
};
</script>

<style>
</style>